import { BILLING_ALIVE, BILLING_ENABLED } from 'reactApp/appHelpers/configHelpers';
import { sendXray } from 'reactApp/utils/ga';

export const sendBillingRadars = () => {
    if (BILLING_ENABLED === false) {
        sendXray('billing_enabled_false');
    }

    if (BILLING_ALIVE === false) {
        sendXray('billing_alive_false');
    }
};
